import { render, staticRenderFns } from "./signActivity.vue?vue&type=template&id=30585b5c&scoped=true"
import script from "./signActivity.vue?vue&type=script&lang=js"
export * from "./signActivity.vue?vue&type=script&lang=js"
import style0 from "./signActivity.vue?vue&type=style&index=0&id=30585b5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30585b5c",
  null
  
)

export default component.exports